export default "<div class=\"loading-bar\" #bar>\r\n    <div class=\"loading-bar__inner\">\r\n          \r\n    </div>\r\n</div>\r\n";